// extracted by mini-css-extract-plugin
export var emptyState = "_58-d";
export var statCard = "_58-c";
export var table = "_58-0";
export var tableCell = "_58-4";
export var tableCellClickable = "_58-5 _58-4";
export var tableCellDefault = "_58-6 _58-4";
export var tableCellEmpty = "_58-8";
export var tableCellWithValue = "_58-7";
export var tableContainer = "_58-e";
export var tableHeaderWeight = "_58-1";
export var tableHeaderZone = "_58-2";
export var tableRowHeader = "_58-3";
export var viewModeButton = "_58-9";
export var viewModeButtonActive = "_58-a _58-9";
export var viewModeButtonInactive = "_58-b _58-9";